import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ScheduleAction } from '../schedule.action';
import { ScheduleTranslator } from '../schedule.translator';

type IDependencies = IClientApiDependencySegment;

export const createScheduleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(ScheduleAction.create.started),
  mergeMap(({ params, resolve, reject }) => {
    return dependencies.api.createSchedule(ScheduleTranslator.toApi(params)).pipe(
      mergeMap((result) => {
        resolve?.();
        return [
          ScheduleAction.create.done({ params, result: { scheduleId: result.id } }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          ScheduleAction.create.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
